import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';


export const createAttributeFunc = createAsyncThunk("create attribute function", async ({ data }, thunkAPI) => {
  try {
    const response = await api.post(`/dashboard/attributes`, data);
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
  }
});

const createAttributeSlicer = createSlice({
  name: "create attribute slicer",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createAttributeFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    })
      .addCase(createAttributeFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(createAttributeFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  }
});

export default createAttributeSlicer.reducer;
